import React, { Component } from 'react';

class LineColorMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Página de Cores de Linha </h2>
                <p>
                    Nesta página pode criar, modificar e apagar Cores de Linha. Uma Cor de Linha é composta por Cor de Fundo, Cor de Texto e Tonalidades (as quais podem ser geradas automaticamente).
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar, modificar e eliminar uma Cor</li>
                    <li>Pesquisar a lista de Cores disponíveis</li>
                    <li>Gerar automaticamente tonalidades claras ou escuras</li>
                </ul>
            </div>
        );
    }
}

export default LineColorMetadata;